import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-address",
  "use": "icon-address-usage",
  "viewBox": "0 0 30 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 36\" id=\"icon-address\"><defs><style>#icon-address .cls-1{fill:#226db6;}</style></defs><path class=\"cls-1\" d=\"M15,.05A14.9,14.9,0,0,0,4.41,25.41L15,35.91,25.57,25.38A14.88,14.88,0,0,0,15,.05Zm5.12,13.26a5.12,5.12,0,0,1-10.22-.42,5.12,5.12,0,1,1,10.22.42Zm0,0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol